var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.donutData.length>0)?_c('GChart',{attrs:{"type":"PieChart","data":_vm.donutData,"options":_vm.donutChartOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }